import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { uniqueId } from 'lodash'
import { Text } from 'src/Components'

import styles from './CheckBox.module.scss'

const propTypes = {
  // attach a class to the checkbox to custom style the label
  classname: PropTypes.string,
  // Whatever passed as children will render as the checkbox description
  children: PropTypes.node.isRequired,
  // required to create a unique id
  name: PropTypes.string.isRequired,
  // for custom label styles
  labelText: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
}

const DefaultLabelText = props => (
  <Text element='span' color='quiet' size='xs' {...props} />
)

const DefaultInput = props => <input type='checkbox' {...props} />

const CheckBox = ({
  className,
  children,
  name,
  id = uniqueId(name),
  labelText,
  input,
  hide,
  ...restProps
}) => {
  const LabelText = labelText || DefaultLabelText
  const Input = input || DefaultInput

  return (
    <label htmlFor={id} className={classnames(styles.root, className)}>
      <Input
        className={classnames(styles.input, hide && styles.hide)}
        id={id}
        name={name}
        {...restProps}
      />
      <LabelText>{children}</LabelText>
    </label>
  )
}

CheckBox.propTypes = propTypes

export default CheckBox
